import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../UserAccountLinker.module.scss';

const LinkToSelf = () => {
    const { t } = useTranslation();
    return (
        <div className={styles.statusCard}>
          <h2>{t("invite.link_to_self_title")}</h2>
          <p>
            {t("invite.link_to_self_message")}
          </p>
          <p>
            <span>{t("invite.invitation_revoked")}</span><br />
            {t("invite.request_new_invitation")}
          </p>
        </div>
    );
};

export default LinkToSelf;